import * as yup from "yup";

export type ContactUserValidationType = yup.InferType<typeof ContactUserValidation>;

export const ContactUserValidation = yup.object().shape({
	subject: yup.string().required("Please select a subject"),
	message: yup.string().optional(),
});
